import React, { useState } from 'react';
import css from './SevaGoshtiSubscription.module.css';

const SevaGoshtiSubscription = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      setStatus('error');
      setMessage('Please enter a valid email address');
      return;
    }

    setStatus('loading');

    // For now, just simulate success - you can integrate with your email service later
    // (Mailchimp, SendGrid, etc.)
    setTimeout(() => {
      setStatus('success');
      setMessage('Hare Krishna! You have been subscribed to Sevā Goṣṭhī.');
      setEmail('');
    }, 1000);
  };

  return (
    <section className={css.root}>
      <div className={css.container}>
        <div className={css.iconContainer}>
          <span className={css.icon}>🙏</span>
        </div>

        <h2 className={css.title}>Join Sevā Goṣṭhī</h2>
        <p className={css.subtitle}>
          Our community newsletter with updates on new products, seva opportunities,
          festival announcements, and spiritual inspiration from our temple community.
        </p>

        <form onSubmit={handleSubmit} className={css.form}>
          <div className={css.inputWrapper}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className={css.input}
              disabled={status === 'loading'}
            />
            <button
              type="submit"
              className={css.button}
              disabled={status === 'loading'}
            >
              {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
            </button>
          </div>

          {message && (
            <p className={status === 'success' ? css.successMessage : css.errorMessage}>
              {message}
            </p>
          )}
        </form>

        <p className={css.privacy}>
          We respect your privacy. Unsubscribe anytime.
        </p>
      </div>
    </section>
  );
};

export default SevaGoshtiSubscription;
